import React, { useState, useEffect } from 'react'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getReportSetting, searchReportSetting } from '../../../redux/actions/reportSetting'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import SearchForNamesWidget from '../../../widgets/searchForNamesWidgets/SearchForNamesWidget'
import { getManageUserRoleSearchName } from '../../../redux/actions/manageAccess'

export default function SearchForNames() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [showEditAll, setShowEditAll] = useState()
  const [error, setError] = useState()
  const [projectCode, setProjectCode] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    // console.log('load ProjectName projectId', projectId)

    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getManageUserRoleSearchName(null, null, 10, 1)
      console.log('_schema', _schema)
      setSchema(_schema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isSubProjectReport>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProjectReport>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  // const onSubmitSearchSubProject = (data) => {
  //   console.log('onSubmitSearch', data)

  //   data.mainProject && handleSearchReportSetting(data.mainProject)
  // }

  return (
    <>
      {schema && (
        <SidebarProposal isSubProjectReport>
          <ContentHeader header={schema?.header} subHeader={schema?.subHeader} />

          <SearchForNamesWidget schema={schema} />
        </SidebarProposal>
      )}
    </>
  )
}

const mockSchema = {
  affectedRows: 0,
  message: null,
  didError: false,
  errorMessage: null,
  model: {
    form: {
      header: 'ค้นหารายชื่อ',
      searchForm: {
        header: null,
        firstName: {
          name: 'firstName',
          label: 'ชื่อ',
          value: null,
        },
        lastName: {
          name: 'lastName',
          label: 'สกุล',
          value: null,
        },
      },
      data: {
        totalSize: 3,
        values: [
          {
            id: '575F28A8-5004-4306-BB03-17D4A76CBE38',
            fullName: 'นายสุภาพ ไทยแท้',
            leaderManage: '12 โครงการ',
            coordinatorSuportor: '1 โครงการ',
            totalSize: 3,
          },
          {
            id: '575F28A8-5004-4306-BB03-17D4A76CBE38',
            fullName: 'นางสาววรรณภา มีเนตรทิพย์',
            leaderManage: '103 โครงการ',
            coordinatorSuportor: '10 โครงการ',
            totalSize: 3,
          },
          {
            id: '575F28A8-5004-4306-BB03-17D4A76CBE38',
            fullName: 'นางสาวชลณิชา อาษา',
            leaderManage: '30 โครงการ',
            coordinatorSuportor: '1 โครงการ',
            totalSize: 3,
          },
        ],
      },
    }
  }
}
